import goldenRulesPdf from '@assets/pdf/golden-rules.pdf';
import { PdfViewer } from '@components';
import { Container } from '@design-system';
import { useGoldenRulesPageVM } from './useGoldenRulesPageVM';

export const GoldenRulesPage: React.FC = () => {
    const { setHasSeenAllPages, navigateBackToModule } = useGoldenRulesPageVM();

    return (
        <div className="golden-rules-page">
            <Container height="fill">
                <PdfViewer
                    file={goldenRulesPdf}
                    setHasSeenAllPages={setHasSeenAllPages}
                    bottomBarPagination
                    callbackOnLastPage={navigateBackToModule}
                    labelNextButtonOnLastPage="Terminer"
                />
            </Container>
        </div>
    );
};
